export default "__VITE_ASSET__BGYDlMKq__"